/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ProductBrand extends React.Component {

	render() {
		return (
            <div>
				{this.props.children}
			</div>
		)
	}
}
;
export default ProductBrand;


// WEBPACK FOOTER //
// ./src/routes/productBrand/index.js